export enum IconName {
  Google = "google",
  Microsoft = "microsoft",
  Hubspot = "hubspot",
  Salesforce = "salesforce",
  UploadDrawer = "upload-drawer",
  DownloadDrawer = "download-drawer",
  QuestionOutline = "question-outline",
  CautionOutline = "caution-outline",
  OpenFolder = "open-folder",
  Search = "search",
  SortDesc = "sort-desc",
  SortAsc = "sort-asc",
  SortDefault = "sort-default",
  HouseEntrance = "house-entrance",
  ArrowDown = "arrow-down",
  MultipleNeutral = "multiple-neutral",
  TaskChecklist = "task-checklist",
  Logout = "logout",
  ArrowButtonLeft = "arrow-button-left",
  Database = "database",
  Cog = "cog",
  NavigationMenuVertical = "navigation-menu-vertical",
  Close = "close",
  PlusOutline = "plus-outline",
  CheckOutline = "check-outline",
  ArrowUpAndDown = "arrow-up-and-down",
  UserOutline = "user-outline",
  UserOptOut = "user-opt-out",
  OfficeFileGraph = "office-file-graph",
  Pencil = "pencil",
  InformationOutline = "information-outline",
  LeftArrowOutline = "left-arrow-outline",
  RightArrowOutline = "right-arrow-outline",
  UpArrowOutline = "up-arrow-outline",
  DownArrowOutline = "down-arrow-outline",
  Check = "check",
  Trash = "trash",
  CircleFilled = "circle-filled",
  PerformanceIncrease = "performance-increase",
  DataFileGraph = "data-file-graph",
  DollarCircle = "dollar-circle",
  MultipleUsers = "multiple-users",
  ChevronDown = "chevron-down",
  ChevronUp = "chevron-up",
  AnalyticsGraph = "analytics-graph",
  TableTools = "table-tools",
  Calendar = "calendar",
  RefreshArrow = "refresh-arrow",
  Lock = "lock",
  Unlock = "unlock",
  Balloon = "balloon",
  Globe = "globe",
  Trophy = "trophy",
  Uploading = "uploading",
  Mail = "mail",
  Phone = "phone",
  Clock = "clock",
  Filter = "filter",
  Scale = "scale",
  BarChart = "bar-chart",
  Percent = "percent",
  Reset = "reset",
  Hierarchy = "hierarchy",
  ExternalLink = "external-link",
  AlertTriangle = "alert-triangle",
  UserGroup = "user-group",
  User = "user",
  Workspace = "workspace",
  OwnerUser = "owner-user",
  AdminUser = "admin-user",
  BasicUser = "basic-user",
  AccessDenied = "access-denied",
  ZoomIn = "zoom-in",
  ZoomOut = "zoom-out",
  MinusOutline = "minus-outline",
  Coins = "coins",
  List = "list",
  ListPlus = "list-plus",
  CurlyBrackets = "curly-brackets",
  Eye = "eye",
  Hourglass = "hourglass",
  Sparkle = "sparkle",
  CloudX = "cloud-x",
  Empty = "empty",
  Lightning = "lightning",
  Clone = "clone",
  Review = "review",
  Loading = "loading",
  ArrowFlow = "arrow-flow",
  ArrowBendUpRight = "arrow-bend-up-right"
}

export const FIELD_DATA_TYPE_OPTIONS = [
  { label: "Text (Text)", value: "TEXT" },
  { label: "Number (123.55)", value: "NUMBER" },
  { label: "Boolean (true/false)", value: "BOOLEAN" },
  { label: "Currency ($100.00)", value: "CURRENCY" },
  { label: "Phone (555-1234)", value: "PHONE" },
  { label: "Email (user@example.com)", value: "EMAIL" },
  { label: "URL (https://...)", value: "URL" },
  { label: "Date (2024-01-15)", value: "DATE" }
];

export const OMITTED_PERSON_FIELDS =
  /**
   * These fields are omitted from the people fields list because they are not
   * valid for use as metrics.
   */
  [
    "Role Name",
    "Name",
    "First Name",
    "Last Name",
    "Email",
    "Employee ID",
    "Manager Name",
    "Manager Employee ID",
    "Manager Email",
    "Indirect Managers"
  ];
